// src/components/Dashboard/PlayerDashboard/PlayerExtras/Comms.js
import React from 'react';

const Comms = () => {
    return (
        <div className="player-comms">
            <h2>Comms</h2>
            <p>This section is reserved for future player communication tools (e.g., notifications, broadcasts).</p>
        </div>
    );
};

export default Comms;
